"use client";

import React, { useState } from "react";
import Link from "next/link";
import { ArrowUpRight, ArrowRight, LayoutGrid, List, Settings } from "lucide-react";
import { INDUSTRY_ICONS } from "@/lib/industryIcons";
import { Industry } from "@/types";

interface IndustryCardProps {
  industry: Industry;
  index: number;
  viewMode: "grid" | "list";
}

export function IndustryCard({ industry }: IndustryCardProps) {
  const Icon = INDUSTRY_ICONS[industry.icon] ?? Settings;

  return (
    <Link href={industry.href}>
      <div
        className="group relative flex h-full flex-col overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white p-6 transition-[border-color,box-shadow] duration-300 hover:border-primary/30 hover:shadow-xl hover:shadow-primary/5"
      >
        {/* Subtle Decoration */}
        <div className="absolute -right-12 -top-12 h-32 w-32 rounded-full bg-primary/5 blur-3xl" />

        {/* Icon & Category */}
        <div className="mb-6 flex items-start justify-between">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-lg shadow-primary/20 transition-transform duration-500 group-hover:scale-105">
            <Icon className="h-6 w-6" />
          </div>
          <span className="rounded-full border border-primary/10 bg-primary/5 px-2.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-primary">
            {industry.category}
          </span>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col">
          <h3 className="mb-2 text-xl font-bold tracking-tight text-slate-900">
            {industry.title}
          </h3>
          <p className="mb-4 line-clamp-2 text-sm leading-relaxed text-slate-600">
            {industry.tagline}
          </p>
          
          <div className="mt-auto pt-6 flex items-center gap-2 text-xs font-bold text-primary transition-colors">
            View Solution
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
          </div>
        </div>
      </div>
    </Link>
  );
}
